import React from 'react';
import LeadsTable from "@/components/Tables/LeadsTable";
import StaticLayoutInner from '@/layouts/StaticLayoutInner';
import TableLayout from '@/layouts/TableLayout';

function UsersLeads() {
  const filters = JSON.stringify({
    filters: [
      {
        "key": "paymentsCount",
        "condition": { "eq": 0 }
      },
      {
        "key": "subscriptionsCount",
        "condition": { "eq": 0 }
      },
    ]
  });

  return (
    <StaticLayoutInner>
      <TableLayout title="Leads">
        <LeadsTable pageSize={10} filters={filters} />
      </TableLayout>
    </StaticLayoutInner>
  );
}

export default UsersLeads;
